import GqlFullCrudTreeForm from './GqlFullCrudTreeForm';
export default GqlFullCrudTreeForm;
